import { all, fork } from 'redux-saga/effects'

import getProtrackByIdSaga from './getProtrackByIdSaga'
import putProtrackSaga from './putProtrackSaga'
import uploadProtrackImagesSaga from './uploadProtrackImagesSaga'
import postProtrackSaga from './postProtrackSaga'

export default function* protrackSaga() {
  yield all([fork(getProtrackByIdSaga), fork(putProtrackSaga), fork(uploadProtrackImagesSaga), fork(postProtrackSaga)])
}
